import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Transition from '../utils/Transition.js';
import useWindowDimensions from '../utils/GetScreenDimensions';

import IC6Logo from '../images/Logo/IC6_Blue.png';
import IC7Logo from '../images/Logo/ic7_orange.png';
import IC7PlusLogo from '../images/Logo/ic7_plus_orange.png';
import IOTPink from '../images/Logo/IoT.png';

import Lottie from 'react-lottie';
import bluetoothData from '../lottie/867-bluetooth.json';
import cellularData from '../lottie/lf30_editor_opmodje1.json';
import animationData1 from '../lottie/lf30_editor_wqq7lwyz.json';
import mapDataIc6 from '../lottie/lf30_editor_tgdqlsrm.json';
import mapDataIc7 from '../lottie/lf30_editor_uka5qjqe.json';

function SolutionsTabs() {
    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const { width } = useWindowDimensions();

    let width_IC7Plus = '49%';
    if (width >= 600) {
        width_IC7Plus = '25%';
    }

    const [tab, setTab] = useState(1);
    const tabs = useRef(null);

    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const device = params.get('device');

        switch (device) {
            case 'ic6':
                setTab(1);
                break;
            case 'ic7':
                setTab(2);
                break;
            case 'ic7plus':
                setTab(3);
                break;
            case 'icx':
                setTab(4);
                break;
            case 'iot':
                setTab(5);
                break;
            default:
                // leave as whatever it already is (default 1)
                break;
        }
    }, [location.search]);


    const wrapperFunction_tab1 = () => {
        setTab(1);
        goToTop();
    };
    const wrapperFunction_tab2 = () => {
        setTab(2);
        goToTop();
    };
    const wrapperFunction_tab3 = () => {
        setTab(3);
        goToTop();
    };
    const wrapperFunction_tab4 = () => {
        setTab(4);
        goToTop();
    };
    const wrapperFunction_tab5 = () => {
        setTab(5);
        goToTop();
    };

    const heightFix = () => {
        if (tabs.current && tabs.current.children[tab - 1]) {
            tabs.current.style.height = tabs.current.children[tab - 1].offsetHeight + 'px';
        }
    };

    const defaultOptionsMapDataIC6 = {
        loop: true,
        autoplay: true,
        animationData: mapDataIc6,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };

    const defaultOptionsMapDataIC7 = {
        loop: true,
        autoplay: true,
        animationData: mapDataIc7,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };

    const defaultOptionBluetooth = {
        loop: true,
        autoplay: true,
        animationData: bluetoothData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };

    const defaultOptionCellular = {
        loop: true,
        autoplay: true,
        animationData: cellularData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };

    const defaultOptionsAnimation = {
        loop: true,
        autoplay: true,
        animationData: animationData1,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };

    useEffect(() => {
        heightFix();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tab]);

    return (
        <section className="relative z-20 py-16 sm:py-20 lg:py-24">
            <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
                {/* ------------------ HEADER + TABS (separate from card) ------------------ */}
                {/* Section header */}
                <div
                    className="max-w-3xl mx-auto text-center pb-6 sm:pb-8"
                    data-aos-id-tabs
                >
                    <p
                        className="text-xs font-semibold tracking-widest text-gray-400 mb-2"
                        data-aos="fade-up"
                        data-aos-anchor="[data-aos-id-tabs]"
                    >
                        
                        
                    </p>
                    <h2
                        className="text-3xl sm:text-4xl font-semibold text-white tracking-tight mb-3"
                        data-aos="fade-up"
                        data-aos-delay="100"
                        data-aos-anchor="[data-aos-id-tabs]"
                    >
                        IC device range for connected mobility.
                    </h2>
                    <p
                        className="text-sm sm:text-base text-gray-300"
                        data-aos="fade-up"
                        data-aos-delay="200"
                        data-aos-anchor="[data-aos-id-tabs]"
                    >
                        Fully white-labelled telematics solutions, combining low-cost hardware, patented analytics
                        and proven low-speed collision detection.
                    </p>
                </div>

                {/* Tabs bar */}
                <div className="max-w-4xl mx-auto mb-8 sm:mb-10">
                    <div
                        className="relative rounded-2xl border border-gray-700 bg-gray-900 bg-opacity-90 shadow-xl"
                        data-aos="fade-up"
                        data-aos-delay="260"
                        data-aos-anchor="[data-aos-id-tabs]"
                    >
                        <div
                            className="absolute inset-x-6 top-0 h-px bg-gradient-to-r from-blue-500 via-yellow-400 to-pink-500 opacity-75"
                            aria-hidden="true"
                        />

                        <div className="relative flex flex-wrap items-center justify-center gap-2 sm:gap-3 px-4 py-3 sm:px-6 sm:py-4">
                            {/* IC6 */}
                            <button
                                className={`group relative inline-flex flex-col items-center justify-center rounded-xl px-4 sm:px-6 py-2 sm:py-2.5 text-xs sm:text-sm font-semibold transition ${
                                    tab === 1
                                        ? 'bg-gray-900 text-blue-400 border border-blue-500 shadow-md'
                                        : 'bg-gray-800 text-gray-300 border border-gray-700 hover:bg-gray-700'
                                }`}
                                onClick={wrapperFunction_tab1}
                            >
                                <div className="flex items-center">
                                    <span
                                        className={`mr-2 h-2 w-2 rounded-full ${
                                            tab === 1 ? 'bg-blue-400' : 'bg-blue-500'
                                        }`}
                                    />
                                    <span>IC6</span>
                                </div>
                                <span className="mt-1 text-xs text-gray-400 hidden sm:block">
                                    Bluetooth
                                </span>
                            </button>

                            {/* IC7 */}
                            <button
                                className={`group relative inline-flex flex-col items-center justify-center rounded-xl px-4 sm:px-6 py-2 sm:py-2.5 text-xs sm:text-sm font-semibold transition ${
                                    tab === 2
                                        ? 'bg-gray-900 text-yellow-400 border border-yellow-500 shadow-md'
                                        : 'bg-gray-800 text-gray-300 border border-gray-700 hover:bg-gray-700'
                                }`}
                                onClick={wrapperFunction_tab2}
                            >
                                <div className="flex items-center">
                                    <span
                                        className={`mr-2 h-2 w-2 rounded-full ${
                                            tab === 2 ? 'bg-yellow-300' : 'bg-yellow-400'
                                        }`}
                                    />
                                    <span>IC7</span>
                                </div>
                                <span className="mt-1 text-xs text-gray-400 hidden sm:block">
                                    Solar / BLE
                                </span>
                            </button>

                            {/* IC7+ */}
                            <button
                                className={`group relative inline-flex flex-col items-center justify-center rounded-xl px-4 sm:px-6 py-2 sm:py-2.5 text-xs sm:text-sm font-semibold transition ${
                                    tab === 3
                                        ? 'bg-gray-900 text-yellow-400 border border-yellow-500 shadow-md'
                                        : 'bg-gray-800 text-gray-300 border border-gray-700 hover:bg-gray-700'
                                }`}
                                onClick={wrapperFunction_tab3}
                            >
                                <div className="flex items-center">
                                    <span
                                        className={`mr-2 h-2 w-2 rounded-full ${
                                            tab === 3 ? 'bg-yellow-300' : 'bg-yellow-400'
                                        }`}
                                    />
                                    <span>IC7+</span>
                                </div>
                                <span className="mt-1 text-xs text-gray-400 hidden sm:block">
                                    Solar / BLE & Cellular
                                </span>
                            </button>

                            {/* ICx */}
                            <button
                                className={`group relative inline-flex flex-col items-center justify-center rounded-xl px-4 sm:px-6 py-2 sm:py-2.5 text-xs sm:text-sm font-semibold transition ${
                                    tab === 4
                                        ? 'bg-gray-900 text-purple-400 border border-purple-500 shadow-md'
                                        : 'bg-gray-800 text-gray-300 border border-gray-700 hover:bg-gray-700'
                                }`}
                                onClick={wrapperFunction_tab4}
                            >
                                <div className="flex items-center">
                                    <span
                                        className={`mr-2 h-2 w-2 rounded-full ${
                                            tab === 4 ? 'bg-purple-300' : 'bg-purple-400'
                                        }`}
                                    />
                                    <span>ICx</span>
                                </div>
                                <span className="mt-1 text-xs text-gray-400 hidden sm:block">
                                    Collision sensing
                                </span>
                            </button>

                            {/* IoT */}
                            <button
                                className={`group relative inline-flex flex-col items-center justify-center rounded-xl px-4 sm:px-6 py-2 sm:py-2.5 text-xs sm:text-sm font-semibold transition ${
                                    tab === 5
                                        ? 'bg-gray-900 text-pink-400 border border-pink-500 shadow-md'
                                        : 'bg-gray-800 text-gray-300 border border-gray-700 hover:bg-gray-700'
                                }`}
                                onClick={wrapperFunction_tab5}
                            >
                                <div className="flex items-center">
                                    <span
                                        className={`mr-2 h-2 w-2 rounded-full ${
                                            tab === 5 ? 'bg-pink-300' : 'bg-pink-400'
                                        }`}
                                    />
                                    <span>IoT</span>
                                </div>
                                <span className="mt-1 text-xs text-gray-400 hidden sm:block">
                                    Bespoke solutions
                                </span>
                            </button>
                        </div>
                    </div>
                </div>

                {/* ------------------ MAIN CARD (products / features / flows / integration) ------------------ */}
                <div
                    className="relative rounded-2xl border border-gray-700 bg-gray-900 bg-opacity-90 shadow-2xl px-4 sm:px-8 py-10 md:py-12"
                    data-aos="fade-in"
                    data-aos-duration="1500"
                    data-aos-anchor-placement="top-bottom"
                >
                    {/* MAIN TAB CONTENT */}
                    <div
                        className="mt-4 sm:mt-6"
                        data-aos="fade-up"
                        ref={tabs}
                    >
                        {/* IC6 */}
                        <Transition
                            show={tab === 1}
                            appear={true}
                            className="w-full"
                            enter="transition ease-in-out duration-500 transform order-first"
                            enterStart="opacity-0 scale-98"
                            enterEnd="opacity-100 scale-100"
                            leave="transition ease-out duration-300 transform absolute"
                            leaveStart="opacity-100 scale-100"
                            leaveEnd="opacity-0 scale-98"
                        >
                            <div className="pb-3 md:pb-2">
                                <div className="max-w-3xl mx-auto text-center pb-6">
                                    <img
                                        className="object-contain w-32 h-32 inline-block mb-3"
                                        src={IC6Logo}
                                        alt="IC6 logo"
                                    />
                                    <h3 className="text-xl sm:text-2xl font-semibold text-gray-100">
                                        A low-cost, self-install, usage-based device.
                                    </h3>
                                </div>

                                <div className="rounded-2xl border border-gray-700 bg-gray-900 bg-opacity-80 shadow-xl p-6 sm:p-8">
                                    <div className="md:grid md:grid-cols-12 md:gap-8 items-center">
                                        {/* Video */}
                                        <figure
                                            className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-5 lg:col-span-5 mb-8 md:mb-0"
                                            data-aos="fade-right"
                                            data-aos-delay="200"
                                        >
                                            <div className="relative overflow-hidden rounded-2xl shadow-lg">
                                                <video
                                                    autoPlay
                                                    muted
                                                    loop
                                                    playsInline
                                                    className="h-full w-full object-cover"
                                                >
                                                    <source
                                                        src="https://agmtwebsitevideo.s3.eu-west-1.amazonaws.com/IC6Square.mp4"
                                                        type="video/mp4"
                                                    />
                                                </video>
                                            </div>
                                        </figure>

                                        {/* Content */}
                                        <div className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-7 lg:col-span-7">
                                            <div className="md:pl-4 lg:pl-8 xl:pl-10 space-y-4">
                                                <p className="text-sm sm:text-base text-gray-100">
                                                    Historically, the adoption of usage-based insurance (UBI) has been
                                                    limited by the cost and complexity of installing hardware and the
                                                    challenge of accurately recording driving data.
                                                </p>
                                                <p className="text-sm sm:text-base text-gray-100">
                                                    IC6 solves this with a simple peel-and-stick installation, powered
                                                    by an internal battery that requires no external wiring.
                                                </p>
                                                <p className="text-sm sm:text-base text-gray-100">
                                                    An inbuilt accelerometer and GPS accurately record driver
                                                    behaviour, journey data and collisions, with transmissions via
                                                    Bluetooth Low Energy tethered to a smartphone.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Transition>

                        {/* IC7 */}
                        <Transition
                            show={tab === 2}
                            appear={true}
                            className="w-full"
                            enter="transition ease-in-out duration-500 transform order-first"
                            enterStart="opacity-0 scale-98"
                            enterEnd="opacity-100 scale-100"
                            leave="transition ease-out duration-300 transform absolute"
                            leaveStart="opacity-100 scale-100"
                            leaveEnd="opacity-0 scale-98"
                        >
                            <div className="pb-3 md:pb-2">
                                <div className="max-w-3xl mx-auto text-center pb-6">
                                    <img
                                        className="object-contain w-32 h-32 inline-block mb-3"
                                        src={IC7Logo}
                                        alt="IC7 logo"
                                    />
                                    <h3 className="text-xl sm:text-2xl font-semibold text-gray-100">
                                        A low-cost, self-install, long-life device.
                                    </h3>
                                </div>

                                <div className="rounded-2xl border border-gray-700 bg-gray-900 bg-opacity-80 shadow-xl p-6 sm:p-8">
                                    <div className="md:grid md:grid-cols-12 md:gap-8 items-center">
                                        {/* Image + Lottie overlays */}
                                        <figure
                                            className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-5 lg:col-span-5 mb-8 md:mb-0"
                                            data-aos="fade-right"
                                            data-aos-delay="200"
                                        >
                                            <div className="relative overflow-hidden rounded-2xl bg-gray-900 shadow-lg">
                                                <div
                                                    className="md:left-16 md:-top-0 left-16 lg:left-16 lg:top-0 transform rotate-90 absolute">
                                                    <Lottie options={defaultOptionsAnimation} height={150}
                                                            width={150}/>
                                                </div>
                                                <div className="absolute -top-12 -right-12">
                                                    <Lottie options={defaultOptionBluetooth} height={200}
                                                            width={200}/>
                                                </div>
                                                <img
                                                    className="w-full h-full object-cover"
                                                    src={require('../images/Dash.png').default}
                                                    width="516"
                                                    height="387"
                                                    alt="IC7 device on dash"
                                                />
                                            </div>
                                        </figure>

                                        {/* Content */}
                                        <div className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-7 lg:col-span-7">
                                            <div className="md:pl-4 lg:pl-8 xl:pl-10 space-y-4">
                                                <p className="text-sm sm:text-base text-gray-100">
                                                    IC7 is a self-standing data-capturing solution with an inbuilt
                                                    3-axis accelerometer and GPS. The low-cost unit connects via BLE
                                                    to a mobile device to transmit data to the cloud.
                                                </p>
                                                <p className="text-sm sm:text-base text-gray-100">
                                                    An internal backup battery supports solar harvesting cells,
                                                    delivering a{' '}
                                                    <span className="text-yellow-400 font-semibold">3–5 year</span>{' '}
                                                    device life.
                                                </p>
                                                <p className="text-sm sm:text-base text-gray-100">
                                                    IC7 is suitable for a wide range of markets, including insurance,
                                                    fleet management, asset tracking and more.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Transition>

                        {/* IC7+ */}
                        <Transition
                            show={tab === 3}
                            appear={true}
                            className="w-full"
                            enter="transition ease-in-out duration-500 transform order-first"
                            enterStart="opacity-0 scale-98"
                            enterEnd="opacity-100 scale-100"
                            leave="transition ease-out duration-300 transform absolute"
                            leaveStart="opacity-100 scale-100"
                            leaveEnd="opacity-0 scale-98"
                        >
                            <div className="pb-3 md:pb-2">
                                <div className="max-w-3xl mx-auto text-center pb-6">
                                    <img
                                        className="object-contain inline-block"
                                        src={IC7PlusLogo}
                                        alt="IC7+ logo"
                                        width={width_IC7Plus}
                                    />
                                    <h3 className="text-xl sm:text-2xl font-semibold text-gray-100 pt-3">
                                        A stand-alone 3-year analytics device.
                                    </h3>
                                </div>

                                <div className="rounded-2xl border border-gray-700 bg-gray-900 bg-opacity-80 shadow-xl p-6 sm:p-8">
                                    <div className="md:grid md:grid-cols-12 md:gap-8 items-center">
                                        {/* Image + Lottie overlays */}
                                        <figure
                                            className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-5 lg:col-span-5 mb-8 md:mb-0"
                                            data-aos="fade-right"
                                            data-aos-delay="200"
                                        >
                                            <div className="relative overflow-hidden rounded-2xl bg-gray-900 shadow-lg">
                                                <div
                                                    className="md:left-16 md:-top-0 left-16 lg:left-16 lg:top-0 transform rotate-90 absolute">
                                                    <Lottie options={defaultOptionsAnimation} height={150}
                                                            width={150}/>
                                                </div>
                                                <div className="absolute -right-16 -top-10 md:-right-10 md:-top-6 opacity-80 pointer-events-none">
                                                    <Lottie
                                                        options={defaultOptionBluetooth}
                                                        height={170}
                                                        width={170}
                                                    />
                                                </div>
                                                <div className="absolute -top-2 right-20">
                                                    <Lottie options={defaultOptionCellular} height={100}
                                                            width={100}/>
                                                </div>
                                                <img
                                                    className="w-full h-full object-cover"
                                                    src={require('../images/Dash.png').default}
                                                    width="516"
                                                    height="387"
                                                    alt="IC7+ device on dash"
                                                />
                                            </div>
                                        </figure>

                                        {/* Content */}
                                        <div className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-7 lg:col-span-7">
                                            <div className="md:pl-4 lg:pl-8 xl:pl-10 space-y-4">
                                                <p className="text-sm sm:text-base text-gray-100">
                                                    IC7+ incorporates all the features of IC7 with the addition of an
                                                    integrated modem, making it truly stand-alone. Combining solar
                                                    harvesting with cellular connectivity, the device operates
                                                    autonomously once mounted.
                                                </p>
                                                <p className="text-sm sm:text-base text-gray-100">
                                                    Data is uploaded to the cloud in near real time, following simple
                                                    self-installation.
                                                </p>
                                                <p className="text-sm sm:text-base text-gray-100">
                                                    Optional extras include LoRa communication, a 9-axis
                                                    accelerometer/gyro, additional sensors and more.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Transition>

                        {/* ICx – microphone crash detection teaser */}
                        <Transition
                            show={tab === 4}
                            appear={true}
                            className="w-full"
                            enter="transition ease-in-out duration-500 transform order-first"
                            enterStart="opacity-0 scale-98"
                            enterEnd="opacity-100 scale-100"
                            leave="transition ease-out duration-300 transform absolute"
                            leaveStart="opacity-100 scale-100"
                            leaveEnd="opacity-0 scale-98"
                        >
                            <div className="pb-3 md:pb-2">
                                <div className="max-w-3xl mx-auto text-center pb-6">
                                    <span className="inline-flex items-center rounded-full bg-purple-900/40 border border-purple-500 px-3 py-1 text-xs font-semibold text-purple-200 mb-3">
                                        Coming soon
                                    </span>
                                    <h3 className="text-2xl sm:text-3xl font-semibold text-purple-200">
                                        ICx – microphone-led crash detection.
                                    </h3>
                                    <p className="text-sm sm:text-base text-gray-300 mt-3">
                                        Our next-generation smart sensor, designed around audio intelligence and crash
                                        detection – with more details to follow.
                                    </p>
                                </div>

                                <div className="rounded-2xl border border-purple-600/60 bg-gradient-to-br from-gray-900 via-gray-900 to-purple-900/40 shadow-xl p-6 sm:p-8">
                                    <div className="md:grid md:grid-cols-12 md:gap-8 items-center">
                                        {/* Image */}
                                        <figure
                                            className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-5 lg:col-span-5 mb-8 md:mb-0"
                                            data-aos="fade-right"
                                            data-aos-delay="200"
                                        >
                                            <div className="relative overflow-hidden rounded-2xl bg-gray-900 shadow-lg">
                                                <img
                                                    className="w-full h-full object-cover opacity-90"
                                                    src={require('../images/ICx.png').default}
                                                    width="516"
                                                    height="387"
                                                    alt="ICx concept device"
                                                />
                                            </div>
                                        </figure>

                                        {/* Content */}
                                        <div className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-7 lg:col-span-7">
                                            <div className="md:pl-4 lg:pl-8 xl:pl-10 space-y-4">
                                                <p className="text-sm sm:text-base text-gray-100">
                                                    ICx explores a new dimension of crash detection, combining
                                                    microphone-based sensing with our established telematics expertise.
                                                </p>
                                                <p className="text-sm sm:text-base text-gray-100">
                                                    The device is designed to complement existing IC hardware and
                                                    platform integrations, adding an additional signal to help identify
                                                    and verify low-speed and complex incidents.
                                                </p>
                                                <p className="text-sm sm:text-base text-gray-400 italic">
                                                    Technical details and availability are under wraps for now – speak
                                                    to us directly if you&apos;d like to be part of early trials.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Transition>

                        {/* IoT */}
                        <Transition
                            show={tab === 5}
                            appear={true}
                            className="w-full"
                            enter="transition ease-in-out duration-500 transform order-first"
                            enterStart="opacity-0 scale-98"
                            enterEnd="opacity-100 scale-100"
                            leave="transition ease-out duration-300 transform absolute"
                            leaveStart="opacity-100 scale-100"
                            leaveEnd="opacity-0 scale-98"
                        >
                            <div className="pb-3 md:pb-2">
                                {/* Section header */}
                                <div className="max-w-3xl mx-auto text-center pb-8 space-y-4">
                                    <img
                                        className="object-contain h-28 w-28 inline-block"
                                        src={IOTPink}
                                        alt="IoT logo"
                                    />

                                    <h3 className="text-2xl sm:text-3xl font-semibold text-gray-100">
                                        Specialist team creating bespoke solutions
                                    </h3>

                                    <p className="text-sm sm:text-base text-gray-200">
                                        From low-power tracking to industrial monitoring, our IoT team blends
                                        custom hardware, firmware and analytics to build solutions around your
                                        use case – not the other way around.
                                    </p>
                                </div>

                                <div className="max-w-5xl mx-auto">
                                    <div
                                        className="grid gap-8 md:gap-10 md:grid-cols-2 lg:grid-cols-2"
                                        data-aos-id-blocks
                                    >
                                        {/* Low-Power Asset Tracking */}
                                        <div
                                            className="relative flex flex-col items-stretch rounded-2xl border border-gray-700 bg-gray-900 bg-opacity-80 px-4 sm:px-6 py-6 shadow-xl overflow-hidden transform transition duration-300 hover:-translate-y-1 hover:shadow-2xl hover:border-pink-400"
                                            data-aos="fade-up"
                                            data-aos-anchor="[data-aos-id-blocks]"
                                        >
                                            <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-pink-500 via-purple-400 to-blue-400" />
                                            <div className="relative flex flex-col h-full">
                                                <h4 className="h4 mb-3 text-gray-100 text-center md:text-left">
                                                    Low-power asset tracking
                                                </h4>
                                                <div className="w-full mb-4" data-aos="fade-up">
                                                    <img
                                                        className="max-w-full mx-auto h-auto rounded-xl transform hover:scale-105 transition duration-700 ease-out"
                                                        src={
                                                            require('../images/venti-views-1cqIcrWFQBI-unsplash Large.jpg')
                                                                .default
                                                        }
                                                        alt="Low power tracking"
                                                    />
                                                </div>
                                                <p className="text-sm sm:text-base text-gray-200 text-center md:text-left">
                                                    Cable-free hardware with configurable GPS reporting and ultra-low
                                                    power transmission — ideal for assets with strict power limits
                                                    that still need accurate location history.
                                                </p>
                                            </div>
                                        </div>

                                        {/* Low-Speed Collision Detection */}
                                        <div
                                            className="relative flex flex-col items-stretch rounded-2xl border border-gray-700 bg-gray-900 bg-opacity-80 px-4 sm:px-6 py-6 shadow-xl overflow-hidden transform transition duration-300 hover:-translate-y-1 hover:shadow-2xl hover:border-pink-400"
                                            data-aos="fade-up"
                                            data-aos-anchor="[data-aos-id-blocks]"
                                        >
                                            <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-pink-500 via-purple-400 to-blue-400" />
                                            <div className="relative flex flex-col h-full">
                                                <h4 className="h4 mb-3 text-gray-100 text-center md:text-left">
                                                    <Link to="/crash-detection" className="hover:text-gray-300">
                                                        Low-speed collision detection
                                                    </Link>
                                                </h4>
                                                <div className="w-full mb-4" data-aos="fade-up">
                                                    <img
                                                        className="max-w-full mx-auto h-auto rounded-xl transform hover:scale-105 transition duration-700 ease-out"
                                                        src={require('../images/JoeCrashScrape.jpg').default}
                                                        alt="Low speed collision"
                                                    />
                                                </div>
                                                <p className="text-sm sm:text-base text-gray-200 text-center md:text-left">
                                                    Developed with the European Space Agency, our analytics distinguish
                                                    genuine low-speed impacts from noise, enabling insurers to price
                                                    risk and handle claims with confidence.
                                                </p>
                                            </div>
                                        </div>

                                        {/* Idling Efficiency */}
                                        <div
                                            className="relative flex flex-col items-stretch rounded-2xl border border-gray-700 bg-gray-900 bg-opacity-80 px-4 sm:px-6 py-6 shadow-xl overflow-hidden transform transition duration-300 hover:-translate-y-1 hover:shadow-2xl hover:border-pink-400"
                                            data-aos="fade-up"
                                            data-aos-anchor="[data-aos-id-blocks]"
                                        >
                                            <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-pink-500 via-purple-400 to-blue-400" />
                                            <div className="relative flex flex-col h-full">
                                                <h4 className="h4 mb-3 text-gray-100 text-center md:text-left">
                                                    Idling efficiency
                                                </h4>
                                                <div className="w-full mb-4" data-aos="fade-up">
                                                    <img
                                                        className="max-w-full mx-auto h-auto rounded-xl transform hover:scale-105 transition duration-700 ease-out"
                                                        src={
                                                            require('../images/shane-mclendon-9jPJrfLTBi0-unsplash Large.jpg')
                                                                .default
                                                        }
                                                        alt="Idling monitoring"
                                                    />
                                                </div>
                                                <p className="text-sm sm:text-base text-gray-200 text-center md:text-left">
                                                    High-sensitivity sensors and IC7+ connectivity surface idling
                                                    hotspots across fleets, helping reduce fuel waste, emissions and
                                                    unproductive machine time.
                                                </p>
                                            </div>
                                        </div>

                                        {/* Pipeline Monitoring */}
                                        <div
                                            className="relative flex flex-col items-stretch rounded-2xl border border-gray-700 bg-gray-900 bg-opacity-80 px-4 sm:px-6 py-6 shadow-xl overflow-hidden transform transition duration-300 hover:-translate-y-1 hover:shadow-2xl hover:border-pink-400"
                                            data-aos="fade-up"
                                            data-aos-anchor="[data-aos-id-blocks]"
                                        >
                                            <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-pink-500 via-purple-400 to-blue-400" />
                                            <div className="relative flex flex-col h-full">
                                                <h4 className="h4 mb-3 text-gray-100 text-center md:text-left">
                                                    Pipeline monitoring
                                                </h4>
                                                <div className="w-full mb-4" data-aos="fade-up">
                                                    <img
                                                        className="max-w-full mx-auto h-auto rounded-xl transform hover:scale-105 transition duration-700 ease-out"
                                                        src={
                                                            require('../images/quinten-de-graaf-L4gN0aeaPY4-unsplash Large.jpg')
                                                                .default
                                                        }
                                                        alt="Pipeline monitoring"
                                                    />
                                                </div>
                                                <p className="text-sm sm:text-base text-gray-200 text-center md:text-left">
                                                    Long-life, low-power devices capture vibration profiles along
                                                    pipelines, with machine learning refining patterns over time to
                                                    detect changes, anomalies and emerging issues.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Transition>
                    </div>

                    {/* FEATURES */}
                    <div className="mt-12 border-t border-gray-700 pt-10">
                        {/* IC6 features */}
                        <Transition
                            show={tab === 1}
                            appear={true}
                            className="w-full"
                            enter="transition ease-in-out duration-500 transform order-first"
                            enterStart="opacity-0 scale-98"
                            enterEnd="opacity-100 scale-100"
                            leave="transition ease-out duration-300 transform absolute"
                            leaveStart="opacity-100 scale-100"
                            leaveEnd="opacity-0 scale-98"
                        >
                            <h2
                                className="h2 mb-4 text-center pb-6 text-gray-100"
                                data-aos="fade-up"
                            >
                                IC6 features
                            </h2>
                            <div className="max-w-sm mx-auto grid gap-8 md:grid-cols-2 lg:grid-cols-3 lg:gap-12 items-start md:max-w-2xl lg:max-w-none">
                                <div className="relative flex flex-col items-center" data-aos="fade-up">
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/money.png').default}
                                        alt="Low cost"
                                    />
                                    <h4 className="h4 mb-2 text-white">Low cost</h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Suitable for all drivers in all vehicles.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="100"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/tools.png').default}
                                        alt="Self-install"
                                    />
                                    <h4 className="h4 mb-2 text-white">Self-install</h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        No appointment, no engineer, no installation costs.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="200"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/brand.png').default}
                                        alt="Branding"
                                    />
                                    <h4 className="h4 mb-2 text-white">Fully white-labelled</h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Full customer branding on both sides of the device.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="300"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/car.png').default}
                                        alt="Driver behaviour"
                                    />
                                    <h4 className="h4 mb-2 text-white">Driver behaviour</h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Acceleration, braking, cornering and speeding events with{' '}
                                        collision detection.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="400"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/link.png').default}
                                        alt="Local storage"
                                    />
                                    <h4 className="h4 mb-2 text-white">Local storage</h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Up to 3 months of data held locally.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="500"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/score.png').default}
                                        alt="Driver scoring"
                                    />
                                    <h4 className="h4 mb-2 text-white">Driver scoring</h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Evaluate performance using a customisable scoring algorithm.
                                    </p>
                                </div>
                            </div>
                        </Transition>

                        {/* IC7 features */}
                        <Transition
                            show={tab === 2}
                            appear={true}
                            className="w-full"
                            enter="transition ease-in-out duration-500 transform order-first"
                            enterStart="opacity-0 scale-98"
                            enterEnd="opacity-100 scale-100"
                            leave="transition ease-out duration-300 transform absolute"
                            leaveStart="opacity-100 scale-100"
                            leaveEnd="opacity-0 scale-98"
                        >
                            <h2
                                className="h2 mb-4 text-center pb-6 text-gray-100"
                                data-aos="fade-up"
                            >
                                IC7 features
                            </h2>
                            <div className="max-w-sm mx-auto grid gap-8 md:grid-cols-2 lg:grid-cols-3 lg:gap-12 items-start md:max-w-2xl lg:max-w-none">
                                <div className="relative flex flex-col items-center" data-aos="fade-up">
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/money_orange.png').default}
                                        alt="Low cost"
                                    />
                                    <h4 className="h4 mb-2 text-white">Low cost</h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Designed for mass deployment.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="100"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/battery.png').default}
                                        alt="Battery life"
                                    />
                                    <h4 className="h4 mb-2 text-white">Long life</h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        3–5 year lifespan with solar harvesting.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="200"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/priority.png').default}
                                        alt="Edge processing"
                                    />
                                    <h4 className="h4 mb-2 text-white">Edge processing</h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Patented on-device intelligence maximises efficiency.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="300"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/tools_orange.png').default}
                                        alt="Self-install"
                                    />
                                    <h4 className="h4 mb-2 text-white">Self-install</h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        No appointment, no engineer, no installation costs.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="400"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/Solar.png').default}
                                        alt="Solar"
                                    />
                                    <h4 className="h4 mb-2 text-white">Solar harvesting</h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Primary power delivered via solar.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="500"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/car_orange.png').default}
                                        alt="Driver behaviour"
                                    />
                                    <h4 className="h4 mb-2 text-white">Driver behaviour</h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Detailed behaviour events and{' '}
                                        collision detection.
                                    </p>
                                </div>
                            </div>
                        </Transition>

                        {/* IC7+ features */}
                        <Transition
                            show={tab === 3}
                            appear={true}
                            className="w-full"
                            enter="transition ease-in-out duration-500 transform order-first"
                            enterStart="opacity-0 scale-98"
                            enterEnd="opacity-100 scale-100"
                            leave="transition ease-out duration-300 transform absolute"
                            leaveStart="opacity-100 scale-100"
                            leaveEnd="opacity-0 scale-98"
                        >
                            <h2
                                className="h2 mb-4 text-center pb-6 text-gray-100"
                                data-aos="fade-up"
                            >
                                IC7+ features
                            </h2>
                            <div className="max-w-sm mx-auto grid gap-8 md:grid-cols-2 lg:grid-cols-3 lg:gap-12 items-start md:max-w-2xl lg:max-w-none">
                                <div className="relative flex flex-col items-center" data-aos="fade-up">
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/Solar.png').default}
                                        alt="Solar"
                                    />
                                    <h4 className="h4 mb-2 text-white">Solar harvesting</h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Primary power from solar harvesting.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="100"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/broadcast.png').default}
                                        alt="Cellular"
                                    />
                                    <h4 className="h4 mb-2 text-white">Cellular</h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Onboard modem for direct uplink to data services.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="200"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/priority.png').default}
                                        alt="FNOL"
                                    />
                                    <h4 className="h4 mb-2 text-white">FNOL</h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Real-time incident notifications.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="300"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/tools_orange.png').default}
                                        alt="Self-install"
                                    />
                                    <h4 className="h4 mb-2 text-white">Self-install</h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        No appointment, no engineer, no installation costs.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="400"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={
                                            require('../images/Icons/steering-wheel_orange.png').default
                                        }
                                        alt="Analytics"
                                    />
                                    <h4 className="h4 mb-2 text-white">Analytics</h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Enhanced sensors, gyro and comms for detailed data capture.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="500"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/car_orange.png').default}
                                        alt="Standalone"
                                    />
                                    <h4 className="h4 mb-2 text-white">Standalone</h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Solar-rechargeable integrated power source and modem.
                                    </p>
                                </div>
                            </div>
                        </Transition>
                    </div>

                    {/* PROCESS FLOW */}
                    <div className="mt-12 border-t border-gray-700 pt-10">
                        {/* IC6 flow */}
                        <Transition
                            show={tab === 1}
                            appear={true}
                            className="w-full"
                            enter="transition ease-in-out duration-500 transform order-first"
                            enterStart="opacity-0 scale-98"
                            enterEnd="opacity-100 scale-100"
                            leave="transition ease-out duration-300 transform absolute"
                            leaveStart="opacity-100 scale-100"
                            leaveEnd="opacity-0 scale-98"
                        >
                            <div className="max-w-3xl mx-auto text-center pb-6">
                                <h2
                                    className="h2 mb-3 pt-2 text-gray-100"
                                    data-aos="fade-up"
                                >
                                    IC6 process flow
                                </h2>
                                <p
                                    className="text-sm sm:text-base text-gray-100"
                                    data-aos="fade-up"
                                    data-aos-delay="200"
                                >
                                    Capturing driver data has never been easier.
                                </p>
                                <div className="relative mt-4 flex justify-center">
                                    <Lottie
                                        options={defaultOptionsMapDataIC6}
                                        height={260}
                                        width={260}
                                    />
                                </div>
                            </div>

                            <div className="max-w-sm mx-auto grid gap-8 md:grid-cols-3 lg:gap-10 items-start md:max-w-none">
                                <div className="relative flex flex-col items-center" data-aos="fade-up">
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/pairing.png').default}
                                        alt="Pair"
                                    />
                                    <h4 className="h4 mb-2 text-gray-100">
                                        <span className="text-gray-100">1</span>. Pair
                                    </h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Users receive their device and follow simple installation instructions via
                                        mobile.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="200"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/steering-wheel.png').default}
                                        alt="Drive"
                                    />
                                    <h4 className="h4 mb-2 text-gray-100">
                                        <span className="text-gray-100">2</span>. Drive
                                    </h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Once paired, the device autonomously captures journey and behaviour data.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="400"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/analyse.png').default}
                                        alt="Analyse"
                                    />
                                    <h4 className="h4 mb-2 text-gray-100">
                                        <span className="text-gray-100">3</span>. Analyse
                                    </h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Insights and raw data are available via customisable platform integrations.
                                    </p>
                                </div>
                            </div>
                        </Transition>

                        {/* IC7 flow */}
                        <Transition
                            show={tab === 2}
                            appear={true}
                            className="w-full"
                            enter="transition ease-in-out duration-500 transform order-first"
                            enterStart="opacity-0 scale-98"
                            enterEnd="opacity-100 scale-100"
                            leave="transition ease-out duration-300 transform absolute"
                            leaveStart="opacity-100 scale-100"
                            leaveEnd="opacity-0 scale-98"
                        >
                            <div className="max-w-3xl mx-auto text-center pb-6">
                                <h2
                                    className="h2 mb-3 text-gray-100"
                                    data-aos="fade-up"
                                >
                                    IC7 process flow
                                </h2>
                                <p
                                    className="text-sm sm:text-base text-gray-100"
                                    data-aos="fade-up"
                                    data-aos-delay="200"
                                >
                                    Capturing driving data has never been easier.
                                </p>
                                <div className="relative mt-4 flex justify-center">
                                    <Lottie
                                        options={defaultOptionsMapDataIC7}
                                        height={260}
                                        width={260}
                                    />
                                </div>
                            </div>

                            <div className="max-w-sm mx-auto grid gap-8 md:grid-cols-3 lg:gap-10 items-start md:max-w-none">
                                <div className="relative flex flex-col items-center" data-aos="fade-up">
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/tools_orange.png').default}
                                        alt="Install"
                                    />
                                    <h4 className="h4 mb-2 text-gray-100">
                                        <span className="text-gray-100">1</span>. Install
                                    </h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Follow simple self-installation instructions.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="200"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={
                                            require('../images/Icons/steering-wheel_orange.png').default
                                        }
                                        alt="Capture"
                                    />
                                    <h4 className="h4 mb-2 text-gray-100">
                                        <span className="text-gray-100">2</span>. Capture
                                    </h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        The device observes and captures data autonomously.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="400"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/analyse_orange.png').default}
                                        alt="Analyse"
                                    />
                                    <h4 className="h4 mb-2 text-gray-100">
                                        <span className="text-gray-100">3</span>. Analyse
                                    </h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Data is available in near real time via customisable platforms.
                                    </p>
                                </div>
                            </div>
                        </Transition>

                        {/* IC7+ flow */}
                        <Transition
                            show={tab === 3}
                            appear={true}
                            className="w-full"
                            enter="transition ease-in-out duration-500 transform order-first"
                            enterStart="opacity-0 scale-98"
                            enterEnd="opacity-100 scale-100"
                            leave="transition ease-out duration-300 transform absolute"
                            leaveStart="opacity-100 scale-100"
                            leaveEnd="opacity-0 scale-98"
                        >
                            <div className="max-w-3xl mx-auto text-center pb-6">
                                <h2
                                    className="h2 mb-3 text-gray-100"
                                    data-aos="fade-up"
                                >
                                    IC7+ process flow
                                </h2>
                                <p
                                    className="text-sm sm:text-base text-gray-100"
                                    data-aos="fade-up"
                                    data-aos-delay="200"
                                >
                                    Capturing driving data has never been easier.
                                </p>
                                <div className="relative mt-4 flex justify-center">
                                    <Lottie
                                        options={defaultOptionsMapDataIC7}
                                        height={260}
                                        width={260}
                                    />
                                </div>
                            </div>

                            <div className="max-w-sm mx-auto grid gap-8 md:grid-cols-3 lg:gap-10 items-start md:max-w-none">
                                <div className="relative flex flex-col items-center" data-aos="fade-up">
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/tools_orange.png').default}
                                        alt="Install"
                                    />
                                    <h4 className="h4 mb-2 text-gray-100">
                                        <span className="text-gray-100">1</span>. Install
                                    </h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Follow simple self-installation instructions.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="200"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={
                                            require('../images/Icons/steering-wheel_orange.png').default
                                        }
                                        alt="Capture"
                                    />
                                    <h4 className="h4 mb-2 text-gray-100">
                                        <span className="text-gray-100">2</span>. Capture
                                    </h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        The device observes and captures data autonomously.
                                    </p>
                                </div>

                                <div
                                    className="relative flex flex-col items-center"
                                    data-aos="fade-up"
                                    data-aos-delay="400"
                                >
                                    <img
                                        className="w-16 h-16 mb-4"
                                        src={require('../images/Icons/analyse_orange.png').default}
                                        alt="Analyse"
                                    />
                                    <h4 className="h4 mb-2 text-gray-100">
                                        <span className="text-gray-100">3</span>. Analyse
                                    </h4>
                                    <p className="text-sm sm:text-base text-gray-100 text-center">
                                        Data is available in near real time via customisable integrations.
                                    </p>
                                </div>
                            </div>
                        </Transition>
                    </div>

                    {/* INTEGRATION */}
                    <div className="mt-12 border-t border-gray-700 pt-10">
                        {/* IC6 integration */}
                        <Transition
                            show={tab === 1}
                            appear={true}
                            className="w-full"
                            enter="transition ease-in-out duration-500 transform order-first"
                            enterStart="opacity-0 scale-98"
                            enterEnd="opacity-100 scale-100"
                            leave="transition ease-out duration-300 transform absolute"
                            leaveStart="opacity-100 scale-100"
                            leaveEnd="opacity-0 scale-98"
                        >
                            <div className="relative w-full overflow-hidden rounded-2xl shadow-2xl px-4 py-8 sm:px-8 sm:py-10">
                                {/* Header row */}
                                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
                                    <div>
                                        <p className="inline-flex items-center rounded-full bg-white/5 px-3 py-1 text-xs font-semibold tracking-wide text-gray-200 uppercase">
                                            Integration
                                        </p>
                                        <h3 className="h2 mt-3 text-white">
                                            IC6 integration
                                        </h3>
                                        <p className="mt-2 text-sm sm:text-base text-gray-300 max-w-xl">
                                            Connect IC6 into your existing ecosystem or deploy it as part of a turnkey, white-labelled platform.
                                        </p>
                                    </div>
                                </div>

                                {/* Main layout */}
                                <div className="grid gap-10 md:grid-cols-12 md:gap-12 items-center">
                                    {/* Image */}
                                    <div
                                        className="md:col-span-5 lg:col-span-6 py-6 px-6"
                                        data-aos="fade-up"
                                    >
                                        <div className="relative">
                                            <div className="pointer-events-none absolute -inset-8 rounded-3xl blur-3xl bg-gradient-to-br from-blue-400 via-blue-800 to-blue-500 opacity-20" />
                                            <img
                                                className="relative w-full rounded-2xl shadow-2xl "
                                                src={require('../images/IC6-Integration.png').default}
                                                width="100%"
                                                height="520"
                                                alt="IC6 integration"
                                            />
                                        </div>
                                    </div>

                                    {/* Text + bullets + CTA */}
                                    <div
                                        className="md:col-span-7 lg:col-span-6"
                                        data-aos="fade-right"
                                    >
                                        <div className="md:pr-2 lg:pr-6 xl:pr-10">
                                            <p className="text-sm sm:text-base text-gray-100 mb-5 leading-relaxed">
                                                IC6 plugs into a secure, cloud-based data layer and white-labelled applications, or feeds into your own stack via APIs and streaming integrations.
                                            </p>

                                            <div className="rounded-2xl p-4 sm:p-5 mb-6">
                                                <p className="text-xs uppercase tracking-wide text-gray-400 mb-3">
                                                    What you get
                                                </p>
                                                <ul className="grid gap-2 sm:gap-3 sm:grid-cols-2 text-sm sm:text-base text-gray-100">
                                                    <li className="flex items-start">
                                                        <svg
                                                            className="mt-1 w-3 h-3 flex-shrink-0 text-emerald-400"
                                                            viewBox="0 0 12 12"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                className="fill-current"
                                                                d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"
                                                            />
                                                        </svg>
                                                        <span className="ml-2">Real-time cloud data processing</span>
                                                    </li>
                                                    <li className="flex items-start">
                                                        <svg
                                                            className="mt-1 w-3 h-3 flex-shrink-0 text-emerald-400"
                                                            viewBox="0 0 12 12"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                className="fill-current"
                                                                d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"
                                                            />
                                                        </svg>
                                                        <span className="ml-2">Remote device configuration</span>
                                                    </li>
                                                    <li className="flex items-start">
                                                        <svg
                                                            className="mt-1 w-3 h-3 flex-shrink-0 text-emerald-400"
                                                            viewBox="0 0 12 12"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                className="fill-current"
                                                                d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"
                                                            />
                                                        </svg>
                                                        <span className="ml-2">Driver behaviour and risk insights</span>
                                                    </li>
                                                    <li className="flex items-start">
                                                        <svg
                                                            className="mt-1 w-3 h-3 flex-shrink-0 text-emerald-400"
                                                            viewBox="0 0 12 12"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                className="fill-current"
                                                                d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"
                                                            />
                                                        </svg>
                                                        <span className="ml-2">API access &amp; message forwarding</span>
                                                    </li>
                                                    <li className="flex items-start sm:col-span-2">
                                                        <svg
                                                            className="mt-1 w-3 h-3 flex-shrink-0 text-emerald-400"
                                                            viewBox="0 0 12 12"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                className="fill-current"
                                                                d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"
                                                            />
                                                        </svg>
                                                        <span className="ml-2">Detailed crash reporting and event timelines</span>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div
                                                className="flex flex-col sm:flex-row sm:items-center gap-3"
                                                data-aos="fade-up"
                                                data-aos-delay="400"
                                            >
                                                <div className="relative inline-flex w-full sm:w-auto group">
                                                    <div
                                                        className="absolute -inset-1 rounded-lg bg-gradient-to-r from-blue-500 via-blue-400 to-indigo-500 opacity-70 group-hover:opacity-100 filter blur-md group-hover:blur-lg transition duration-500 ease-out animate-pulse"
                                                        aria-hidden="true"
                                                    />

                                                    <a
                                                        href="/platform-solutions"
                                                        className="relative inline-flex w-full sm:w-auto items-center justify-center rounded-lg bg-blue-500 px-8 sm:px-10 py-3.5 text-sm sm:text-base font-semibold text-white shadow-lg hover:bg-blue-600 hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-gray-900 transition"
                                                    >
                                                        Explore our software platform
                                                    </a>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Transition>

                        {/* IC7 integration */}
                        <Transition
                            show={tab === 2}
                            appear={true}
                            className="w-full"
                            enter="transition ease-in-out duration-500 transform order-first"
                            enterStart="opacity-0 scale-98"
                            enterEnd="opacity-100 scale-100"
                            leave="transition ease-out duration-300 transform absolute"
                            leaveStart="opacity-100 scale-100"
                            leaveEnd="opacity-0 scale-98"
                        >
                            <div className="space-y-6">
                                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                                    <h3 className="h2 mb-0 text-white">
                                        IC7 integration
                                    </h3>
                                </div>

                                <div className="grid gap-10 md:gap-12 lg:gap-16 lg:grid-cols-2 lg:items-center">
                                    <div
                                        className="max-w-xl md:max-w-none md:w-full mx-auto px-6 py-6"
                                        data-aos="fade-up"
                                    >
                                        <div className="relative">
                                            <div
                                                className="pointer-events-none absolute -inset-3 rounded-3xl bg-gradient-to-br from-yellow-400 via-orange-400 to-pink-500 opacity-20"
                                                aria-hidden="true"
                                            />
                                            <img
                                                className="relative md:max-w-full rounded-2xl shadow-2xl"
                                                src={require('../images/IC-IntegrationIC7.png').default}
                                                width="100%"
                                                height="520"
                                                alt="IC7 integration"
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className="max-w-xl md:max-w-none md:w-full mx-auto"
                                        data-aos="fade-right"
                                    >
                                        <div className="md:pr-2 lg:pr-6 xl:pr-8 space-y-5">
                                            <p className="text-sm sm:text-base text-gray-100">
                                                IC7 connects directly into our telematics platform or into your
                                                existing environment via secure APIs. Real-time event data, long-life
                                                hardware and edge intelligence combine to power modern UBI, fleet,
                                                and asset programmes.
                                            </p>

                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                                <div className="flex items-start space-x-2">
                                                    <svg
                                                        className="w-3 h-3 mt-1 flex-shrink-0 fill-current text-green-500"
                                                        viewBox="0 0 12 12"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                                                    </svg>
                                                    <span className="text-sm sm:text-base text-gray-100">
                                                        Real-time cloud data processing
                                                    </span>
                                                </div>

                                                <div className="flex items-start space-x-2">
                                                    <svg
                                                        className="w-3 h-3 mt-1 flex-shrink-0 fill-current text-green-500"
                                                        viewBox="0 0 12 12"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                                                    </svg>
                                                    <span className="text-sm sm:text-base text-gray-100">
                                                        Remote device configuration &amp; control
                                                    </span>
                                                </div>

                                                <div className="flex items-start space-x-2">
                                                    <svg
                                                        className="w-3 h-3 mt-1 flex-shrink-0 fill-current text-green-500"
                                                        viewBox="0 0 12 12"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                                                    </svg>
                                                    <span className="text-sm sm:text-base text-gray-100">
                                                        Driver behaviour &amp; risk insights
                                                    </span>
                                                </div>

                                                <div className="flex items-start space-x-2">
                                                    <svg
                                                        className="w-3 h-3 mt-1 flex-shrink-0 fill-current text-green-500"
                                                        viewBox="0 0 12 12"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                                                    </svg>
                                                    <span className="text-sm sm:text-base text-gray-100">
                                                        APIs, message forwarding &amp; FNOL support
                                                    </span>
                                                </div>
                                            </div>

                                            <div
                                                className="flex flex-col sm:flex-row sm:items-center gap-3"
                                                data-aos="fade-up"
                                                data-aos-delay="400"
                                            >
                                                <div className="relative inline-flex w-full sm:w-auto group">
                                                    <div
                                                        className="absolute -inset-1 rounded-lg bg-gradient-to-r from-yellow-400 via-orange-400 to-pink-500 opacity-70 group-hover:opacity-100 filter blur-md group-hover:blur-lg transition duration-500 ease-out animate-pulse"
                                                        aria-hidden="true"
                                                    />

                                                    <a
                                                        href="/platform-solutions"
                                                        className="relative inline-flex w-full sm:w-auto items-center justify-center rounded-lg bg-yellow-500 px-8 sm:px-10 py-3.5 text-sm sm:text-base font-semibold text-gray-900 shadow-lg hover:bg-yellow-400 hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-yellow-300 focus:ring-offset-2 focus:ring-offset-gray-900 transition"
                                                    >
                                                        Explore our software platform
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Transition>

                        {/* IC7+ integration */}
                        <Transition
                            show={tab === 3}
                            appear={true}
                            className="w-full"
                            enter="transition ease-in-out duration-500 transform order-first"
                            enterStart="opacity-0 scale-98"
                            enterEnd="opacity-100 scale-100"
                            leave="transition ease-out duration-300 transform absolute"
                            leaveStart="opacity-100 scale-100"
                            leaveEnd="opacity-0 scale-98"
                        >
                            <div className="space-y-6">
                                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                                    <h3 className="h2 mb-0 text-white">
                                        IC7+ integration
                                    </h3>
                                </div>

                                <div className="grid gap-10 md:gap-12 lg:gap-16 lg:grid-cols-2 lg:items-center">
                                    <div
                                        className="max-w-xl md:max-w-none md:w-full mx-auto px-6 py-6"
                                        data-aos="fade-up"
                                    >
                                        <div className="relative">
                                            <div
                                                className="pointer-events-none absolute -inset-3 rounded-3xl bg-gradient-to-br from-yellow-400 via-orange-400 to-pink-500 opacity-20"
                                                aria-hidden="true"
                                            />
                                            <img
                                                className="relative md:max-w-full rounded-2xl shadow-2xl"
                                                src={require('../images/IC-IntegrationIC7.png').default}
                                                width="100%"
                                                height="520"
                                                alt="IC7+ integration"
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className="max-w-xl md:max-w-none md:w-full mx-auto"
                                        data-aos="fade-right"
                                    >
                                        <div className="md:pr-2 lg:pr-6 xl:pr-8 space-y-5">
                                            <p className="text-sm sm:text-base text-gray-100">
                                                IC7+ combines solar harvesting, onboard cellular and edge analytics to
                                                stream rich event data directly to the AGM software platform or into
                                                your own systems. Once mounted, it operates autonomously — ideal for
                                                long-life programmes and remote assets.
                                            </p>

                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                                <div className="flex items-start space-x-2">
                                                    <svg
                                                        className="w-3 h-3 mt-1 flex-shrink-0 fill-current text-green-500"
                                                        viewBox="0 0 12 12"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                                                    </svg>
                                                    <span className="text-sm sm:text-base text-gray-100">
                                                        Real-time cloud data processing from stand-alone hardware
                                                    </span>
                                                </div>

                                                <div className="flex items-start space-x-2">
                                                    <svg
                                                        className="w-3 h-3 mt-1 flex-shrink-0 fill-current text-green-500"
                                                        viewBox="0 0 12 12"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                                                    </svg>
                                                    <span className="text-sm sm:text-base text-gray-100">
                                                        Remote configuration, updates and health monitoring
                                                    </span>
                                                </div>

                                                <div className="flex items-start space-x-2">
                                                    <svg
                                                        className="w-3 h-3 mt-1 flex-shrink-0 fill-current text-green-500"
                                                        viewBox="0 0 12 12"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                                                    </svg>
                                                    <span className="text-sm sm:text-base text-gray-100">
                                                        Advanced analytics, FNOL and incident intelligence
                                                    </span>
                                                </div>

                                                <div className="flex items-start space-x-2">
                                                    <svg
                                                        className="w-3 h-3 mt-1 flex-shrink-0 fill-current text-green-500"
                                                        viewBox="0 0 12 12"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                                                    </svg>
                                                    <span className="text-sm sm:text-base text-gray-100">
                                                        APIs, message forwarding and flexible data export options
                                                    </span>
                                                </div>
                                            </div>

                                            <div
                                                className="flex flex-col sm:flex-row sm:items-center gap-3"
                                                data-aos="fade-up"
                                                data-aos-delay="400"
                                            >
                                                <div className="relative inline-flex w-full sm:w-auto group">
                                                    <div
                                                        className="absolute -inset-1 rounded-lg bg-gradient-to-r from-yellow-400 via-orange-400 to-pink-500 opacity-70 group-hover:opacity-100 filter blur-md group-hover:blur-lg transition duration-500 ease-out animate-pulse"
                                                        aria-hidden="true"
                                                    />

                                                    <a
                                                        href="/platform-solutions"
                                                        className="relative inline-flex w-full sm:w-auto items-center justify-center rounded-lg bg-yellow-500 px-8 sm:px-10 py-3.5 text-sm sm:text-base font-semibold text-gray-900 shadow-lg hover:bg-yellow-400 hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-yellow-300 focus:ring-offset-2 focus:ring-offset-gray-900 transition"
                                                    >
                                                        Explore our software platform
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Transition>

                        {/* Bottom mini tab switcher */}
                        <div className="max-w-4xl mx-auto pt-10">
                            <h4
                                className="h4 mb-4 text-white text-center"
                                data-aos="fade-up"
                                data-aos-anchor="[data-aos-id-tabs]"
                            >
                                Explore other devices in the range
                            </h4>
                            <div
                                className="flex flex-wrap justify-center gap-2 sm:gap-3"
                                data-aos="fade-up"
                                data-aos-delay="300"
                                data-aos-anchor="[data-aos-id-tabs]"
                            >
                                <button
                                    className={`inline-flex items-center font-medium px-4 py-1 rounded-full transition ${
                                        tab === 1
                                            ? 'bg-gray-900 border-b-2 border-blue-500'
                                            : 'bg-gray-800 border border-gray-700'
                                    }`}
                                    onClick={wrapperFunction_tab1}
                                >
                                    <span
                                        className={`text-lg font-extrabold tracking-tight mx-1 text-blue-500 ${
                                            tab !== 1 && 'opacity-60'
                                        }`}
                                    >
                                        IC6
                                    </span>
                                </button>
                                <button
                                    className={`inline-flex items-center font-medium px-4 py-1 rounded-full transition ${
                                        tab === 2
                                            ? 'bg-gray-900 border-b-2 border-yellow-500'
                                            : 'bg-gray-800 border border-gray-700'
                                    }`}
                                    onClick={wrapperFunction_tab2}
                                >
                                    <span
                                        className={`text-lg font-extrabold tracking-tight mx-1 text-yellow-500 ${
                                            tab !== 2 && 'opacity-60'
                                        }`}
                                    >
                                        IC7
                                    </span>
                                </button>
                                <button
                                    className={`inline-flex items-center font-medium px-4 py-1 rounded-full transition ${
                                        tab === 3
                                            ? 'bg-gray-900 border-b-2 border-yellow-500'
                                            : 'bg-gray-800 border border-gray-700'
                                    }`}
                                    onClick={wrapperFunction_tab3}
                                >
                                    <span
                                        className={`text-lg font-extrabold tracking-tight mx-1 text-yellow-500 ${
                                            tab !== 3 && 'opacity-60'
                                        }`}
                                    >
                                        IC7+
                                    </span>
                                </button>
                                <button
                                    className={`inline-flex items-center font-medium px-4 py-1 rounded-full transition ${
                                        tab === 4
                                            ? 'bg-gray-900 border-b-2 border-purple-500'
                                            : 'bg-gray-800 border border-gray-700'
                                    }`}
                                    onClick={wrapperFunction_tab4}
                                >
                                    <span
                                        className={`text-lg font-extrabold tracking-tight mx-1 text-purple-400 ${
                                            tab !== 4 && 'opacity-60'
                                        }`}
                                    >
                                        ICx
                                    </span>
                                </button>
                                <button
                                    className={`inline-flex items-center font-medium px-4 py-1 rounded-full transition ${
                                        tab === 5
                                            ? 'bg-gray-900 border-b-2 border-pink-500'
                                            : 'bg-gray-800 border border-gray-700'
                                    }`}
                                    onClick={wrapperFunction_tab5}
                                >
                                    <span
                                        className={`text-lg font-extrabold tracking-tight mx-1 text-pink-500 ${
                                            tab !== 5 && 'opacity-60'
                                        }`}
                                    >
                                        IoT
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default SolutionsTabs;
